import React from "react";
import {observer} from "mobx-react-lite";
import {Button} from "@mui/material";
import {useMst} from "../../../../../mobx";
import {useFormContext} from "react-hook-form";
import {useHistory} from "react-router-dom";

export default observer(function () {
  const { questionsStore } = useMst();
  const { deleteQuestion } = questionsStore;
  const { getValues } = useFormContext();
  const { push } = useHistory();

  const onDelete = async () => {
    try {
      await deleteQuestion(getValues("id"))
      push("/")
    } catch (e) {}
  }

  return getValues("id") ? <Button  variant={"text"} color={"error"} onClick={onDelete}>Удалить задачу</Button> : null;
})